import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ExportarDropbox } from '../models/exportar-dropbox.model';
import { ExportarDropboxService } from '../services/exportar-dropbox.service';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-exportar-dropbox-list',
  templateUrl: './exportar-dropbox-list.component.html',
  styleUrls: ['./exportar-dropbox-list.component.scss']
})
export class ExportarDropboxListComponent extends BaseListComponent<ExportarDropbox> implements OnInit, OnDestroy {

  exportarList: ExportarDropbox[];

  constructor(
    private myService: ExportarDropboxService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.exportarList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/projetos/exportar-dropbox/adicionar'];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
      }
    });
  }

  editar(id: number) {
    return ['/projetos/exportar-dropbox/', id];
  }
}
